import React from 'react';
import { ITabProps } from '../types';

const Tab: React.FC<React.PropsWithChildren<ITabProps>> = ({ children }) => (
  <>{children}</>
);

export default Tab;
